import React from 'react';
import { Loader2 } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

// Per-group prayer wall: tally + open requests + answered testimonies.
const PrayerWall = ({ wall, prayWall, answerWall }) => {
  const { t } = useLanguage();
  return (
  <div className="flex-1 overflow-y-auto p-4 space-y-4" data-testid="prayer-wall">
    {!wall ? (
      <div className="flex justify-center py-12"><Loader2 className="w-6 h-6 animate-spin text-muted-foreground" /></div>
    ) : (
      <>
        <div className="text-center bg-amber-50 dark:bg-amber-950/30 rounded-xl py-4" data-testid="wall-tally">
          <p className="text-3xl font-bold text-amber-600">{wall.total_prayers_offered}</p>
          <p className="text-xs text-muted-foreground uppercase tracking-wide">{t('messages.prayersOffered')}</p>
        </div>
        <div>
          <p className="text-[11px] font-semibold text-muted-foreground uppercase tracking-wide mb-2">{t('messages.open')} · {wall.open.length}</p>
          {wall.open.length === 0 ? <p className="text-sm text-muted-foreground">{t('messages.noOpenRequests')}</p> :
            wall.open.map((p) => (
              <div key={p.id} className="border rounded-xl p-3 mb-2" data-testid={`wall-open-${p.id}`}>
                <p className="text-sm break-words">{p.text}</p>
                <p className="text-[11px] text-muted-foreground mb-1">{p.author_name}</p>
                <div className="flex items-center gap-2">
                  <button onClick={() => prayWall(p.id)} className={`text-xs rounded-full px-2 py-0.5 ${p.i_prayed ? 'bg-amber-500 text-white' : 'bg-amber-100 dark:bg-amber-900/50 text-amber-800 dark:text-amber-300'}`} data-testid={`wall-pray-${p.id}`}>🙏 {t('messages.praying')} · {p.pray_count}</button>
                  {p.is_mine && <button onClick={() => answerWall(p.id)} className="text-xs rounded-full px-2 py-0.5 bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-400" data-testid={`wall-answer-${p.id}`}>{t('messages.answered')}</button>}
                </div>
              </div>
            ))}
        </div>
        <div>
          <p className="text-[11px] font-semibold text-green-700 dark:text-green-400 uppercase tracking-wide mb-2">{t('messages.testimonies')} · {wall.answered.length}</p>
          {wall.answered.length === 0 ? <p className="text-sm text-muted-foreground">{t('messages.noTestimonies')}</p> :
            wall.answered.map((p) => (
              <div key={p.id} className="border border-green-200 dark:border-green-900 bg-green-50/50 dark:bg-green-950/20 rounded-xl p-3 mb-2" data-testid={`wall-answered-${p.id}`}>
                <p className="text-sm break-words">{p.text}</p>
                <p className="text-[11px] text-muted-foreground">{p.author_name} · 🙏 {p.pray_count} · <span className="text-green-700 dark:text-green-400 font-semibold">{t('messages.answeredBadge')}</span></p>
              </div>
            ))}
        </div>
      </>
    )}
  </div>
  );
};

export default PrayerWall;
